import React from 'react';
import './HomeRoles.css';

const WHY_ITEMS = [
  {
    text: 'Mesleki koordinasyon ve ortak referans',
    image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=600&q=80',
    alt: 'Ekip çalışması ve koordinasyon',
  },
  {
    text: 'Yetkinlik odaklı sicil ve tanınırlık',
    image: 'https://images.unsplash.com/photo-1589939705384-5185137a739f?w=600&q=80',
    alt: 'Yetkinlik ve belgelendirme',
  },
  {
    text: 'Sanayi ile doğrudan iş birliği imkânları',
    image: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=600&q=80',
    alt: 'Sanayi ve üretim',
  },
  {
    text: 'Güncel standartlar ve rehber dokümanlar',
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&q=80',
    alt: 'Kalite standartları',
  },
];

const IconStandards = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10 9 9 9 8 9" />
  </svg>
);

const IconDocument = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="12" y1="18" x2="12" y2="12" />
    <line x1="9" y1="15" x2="15" y2="15" />
  </svg>
);

const IconCheck = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);

const IconHandshake = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path d="M18 20V10M12 20V4M6 20v-6" />
    <path d="M6 14l6-6 6 6" />
  </svg>
);

const ROLES = [
  {
    title: 'Mesleki standartların gelişimine katkı sağlamak',
    desc: 'Ortak mesleki çerçeve, yetkinlik tanımları ve rehber dokümanlarla sektörde tutarlılık ve tanınırlık.',
    Icon: IconStandards,
  },
  {
    title: 'Referans dokümanlar oluşturmak',
    desc: 'Uygulama rehberleri ve teknik dokümanlarla kalite mühendisliği pratiğinin güçlendirilmesi.',
    Icon: IconDocument,
  },
  {
    title: 'Sicil ve yetkinlik sistemi geliştirmek',
    desc: 'Meslek mensuplarının kayıt altına alınması ve yetkinliklerin doğrulanabilir şekilde belgelenmesi.',
    Icon: IconCheck,
  },
  {
    title: 'Sanayi ile iş birliği kurmak',
    desc: 'Eğitim, uzman yönlendirme ve kurumsal gelişim çalışmaları ile kalite kültürünün yaygınlaştırılması.',
    Icon: IconHandshake,
  },
];

const HomeRoles = ({ onNavigate }) => {
  return (
    <section className="home-roles">
      <div className="container">
        {/* Neden TKMB? - Modern split layout with image */}
        <div className="home-why-block">
          <div className="home-why-wrapper">
            <div className="home-why-image-wrap">
              <img
                src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=800&q=80"
                alt="Kalite yönetimi ve profesyonel ekip"
                className="home-why-image"
              />
              <div className="home-why-image-overlay" aria-hidden="true" />
            </div>
            <div className="home-why-content">
              <span className="home-why-label">Neden TKMB?</span>
              <h2 className="home-why-title">Kalite mühendisliğinin ulusal platformu</h2>
              <p className="home-why-text">
                TKMB, kalite mühendisliği alanında faaliyet gösteren profesyonelleri bir araya getiren ulusal bir platformdur.
                Mesleki standartların gelişimi, sicil ve yetkinlik sistemi ile sanayi iş birlikleri sayesinde kalite kültürünün
                kurumsal düzeyde yaygınlaşmasına katkı sağlamayı hedefler.
              </p>
              <div className="home-why-cards">
                {WHY_ITEMS.map((item, index) => (
                  <div key={index} className="home-why-card">
                    <div className="home-why-card-image">
                      <img src={item.image} alt={item.alt} loading="lazy" />
                      <span className="home-why-card-check" aria-hidden="true">✓</span>
                    </div>
                    <p className="home-why-card-text">{item.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <h2 className="home-roles-title home-roles-title-main">TKMB'nin Temel Rolü</h2>
        <div className="home-roles-grid">
          {ROLES.map((item, index) => (
            <div key={index} className="home-role-card">
              <span className="home-role-icon" aria-hidden="true">
                <item.Icon />
              </span>
              <h3 className="home-role-title">{item.title}</h3>
              <p className="home-role-desc">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeRoles;
